import React, { useEffect, useState } from 'react';
import './AddOpinionContainer.scss';
import { FormControl, TextField, Select, MenuItem } from '@mui/material';
import { createOpinion } from '../../data/api';
import { Bounce, ToastContainer, toast } from 'react-toastify';

export const AddOpinionContainer = ({ toggleAddOpinion }) => {
  const [opinionText, setOpinionText] = useState('');
  const [selectedSubject, setSelectedSubject] = useState('');
  const [selectedCareer, setSelectedCareer] = useState('');
  const [selectedCourse, setSelectedCourse] = useState('');
  const [subjects, setSubjects] = useState([]);
  const [courses, setCourses] = useState([]);
  const [data, setData] = useState([]);

  useEffect(() => {
    // Cargar el JSON y guardar los datos en el estado
    const loadData = async () => {
      const content = require('../../data/horarios.json');
      setData(content);
    };
    loadData();
  }, []);

  const handleCareerChange = (event) => {
    const career = event.target.value;
    setSelectedCareer(career);
    
    // Filtrar las materias según la especialidad seleccionada
    const filteredSubjects = data.filter(item => item.esp === career);
    setSubjects([...new Set(filteredSubjects.map(item => item.subject))]); // Eliminar duplicados
    setSelectedSubject(''); // Resetear selección de materia
    setSelectedCourse('');  // Resetear selección de comisión
  };

  const handleSubjectChange = (event) => {
    const subject = event.target.value;
    setSelectedSubject(subject);
    
    // Filtrar las comisiones según la materia seleccionada
    const filteredCourses = data.filter(item => item.subject === subject);
    setCourses([...new Set(filteredCourses.map(item => item.course))]); // Eliminar duplicados
    setSelectedCourse(''); // Resetear selección de comisión
  };

  const handleCourseChange = (event) => {
    setSelectedCourse(event.target.value);
  };

  const handleOpinionChange = (event) => {
    setOpinionText(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (opinionText === '' || selectedSubject === '' || selectedCareer === '' || selectedCourse === '') {
      toast.error('Completa todos los campos antes de enviar la opinión.', {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "dark",
        transition: Bounce,
      });
      return;
    }

    const opinion = {
      content: opinionText,
      subject: selectedSubject,
      career: selectedCareer,
      course: selectedCourse,
      likes: [],
      dislikes: [],
      user: localStorage.getItem('userId'),
    };

    const resp = await createOpinion(opinion, localStorage.getItem('userId'));

    if (resp.status === 'success') {
      toast.success('¡Opinión creada!', {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "dark",
        transition: Bounce,
      });

      // Recargar la página después de 1 segundo
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else {
      toast.error('Hubo un error al crear la opinión.', {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "dark",
        transition: Bounce,
      });
    }
  };

  return (
    <div className='add-opinion-background'>
      <div className='add-opinion-container'>
        <h3>Agregar Opinión</h3>
        <div className='add-opinion-hr'></div>
        <FormControl fullWidth>
          <Select
            style={{ margin: 10, fontFamily: 'Sofia Sans, sans-serif' }}
            value={selectedCareer}
            onChange={handleCareerChange}
            displayEmpty
            inputProps={{ 'aria-label': 'Carrera' }}
            variant="outlined"
          >
            <MenuItem value="" disabled>Selecciona una especialidad o categoría</MenuItem>
            <MenuItem value="9">Ingeniería Electrónica</MenuItem>
            <MenuItem value="31">Ingeniería Civil</MenuItem>
            <MenuItem value="7">Ingeniería Eléctrica</MenuItem>
            <MenuItem value="27">Ingeniería Química</MenuItem>
            <MenuItem value="17">Ingeniería Mecánica</MenuItem>
            <MenuItem value="24">Ingeniería Industrial</MenuItem>
            <MenuItem value="H">Homogenéas</MenuItem>
          </Select>

          <Select
            style={{ margin: 10, fontFamily: 'Sofia Sans, sans-serif' }}
            value={selectedSubject}
            onChange={handleSubjectChange}
            displayEmpty
            inputProps={{ 'aria-label': 'Materia' }}
            variant="outlined"
            disabled={!selectedCareer} // Deshabilitar si no hay especialidad seleccionada
          >
            <MenuItem value="" disabled>Selecciona una materia</MenuItem>
            {subjects.map(subject => (
              <MenuItem key={subject} value={subject}>{subject}</MenuItem>
            ))}
          </Select>

          <Select
            style={{ margin: 10, fontFamily: 'Sofia Sans, sans-serif' }}
            value={selectedCourse}
            onChange={handleCourseChange}
            displayEmpty
            inputProps={{ 'aria-label': 'Comisión/Curso' }}
            variant="outlined"
            disabled={!selectedSubject} // Deshabilitar si no hay materia seleccionada
          >
            <MenuItem value="" disabled>Selecciona una comisión o curso</MenuItem>
            {courses.map(course => (
              <MenuItem key={course} value={course}>{course}</MenuItem>
            ))}
          </Select>

          <TextField
            style={{ margin: 10, fontFamily: 'Sofia Sans, sans-serif' }}
            value={opinionText}
            onChange={handleOpinionChange}
            label="Escribe tu opinión"
            variant="outlined"
            multiline
            rows={4}
          />
        </FormControl>
        <button className="btn-create" onClick={handleSubmit}>Crear Opinión</button>
        <button className='btn-cancel' onClick={toggleAddOpinion}>Cancelar</button>
      </div>
      <ToastContainer />
    </div>
  );
};
